var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import DefaultIcon from '../../../components/Atoms/Icon/Icon';
import { IconName } from '../../../components/Atoms/Icon/Icon.enum';
let customIcons = {};
export function init(icons) {
    customIcons = icons;
}
export const Icon = (_a) => {
    var { name } = _a, props = __rest(_a, ["name"]);
    if (name.toLowerCase().includes('search')) {
        return customIcons[name] || _jsx(DefaultIcon, Object.assign({ name: IconName.SEARCH }, props), void 0);
    }
    return customIcons[name] || _jsx(DefaultIcon, Object.assign({ name: name }, props), void 0);
};
//# sourceMappingURL=iconsHelper.js.map